import { render, staticRenderFns } from "./AppTabsSlider.vue?vue&type=template&id=4811c4da&scoped=true&"
import script from "./AppTabsSlider.vue?vue&type=script&lang=js&"
export * from "./AppTabsSlider.vue?vue&type=script&lang=js&"
import style0 from "./AppTabsSlider.vue?vue&type=style&index=0&id=4811c4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811c4da",
  null
  
)

export default component.exports